import React from 'react';
import Form, { Actions, Switch } from '../../../Components/Form';

const TrustDeviceChallenge = ({ onSubmit }) => {
    return <Form onSubmit={onSubmit}>
        <Switch label="Trust this device" name="trustDevice" />
        <Actions submit={{label: 'Continue'}} />
    </Form>;
};

export default TrustDeviceChallenge;
